export type OlderHistoryResult = 'visible' | 'empty-more' | 'end';

/** Повторяет загрузку технических страниц, пока не найдётся видимое сообщение, конец или лимит. */
export async function loadEmptyHistoryUntilVisible(
  load: () => Promise<OlderHistoryResult>,
  maxIterations: number,
  isCancelled: () => boolean = () => false,
): Promise<void> {
  for (let attempt = 0; attempt < maxIterations && !isCancelled(); attempt++) {
    if (await load() !== 'empty-more') return;
  }
}
